import { useState, memo } from 'react'
import cn from 'classnames'
import { useInView } from 'react-intersection-observer'
import dynamic from 'next/dynamic'
// Components
import styles from './Categories.module.scss'
import Button from '../newButton/Button'

const CategoryCard = memo(dynamic(() => import('./CategoryCard')))
const CardCategoriesMobile = memo(
  dynamic(
    () => import('@/components/cardCategoriesMobile/cardCategoriesMobile')
  )
)

type CategoriesProps = {
  categories: any[]
  title: string
  isLanding?: boolean
}

export default function Categories({
  categories,
  title,
  isLanding,
}: CategoriesProps) {
  const { ref, inView } = useInView({
    triggerOnce: true,
  })

  const [showAll, setShowAll] = useState(false)
  const categoriesToShow = showAll ? categories : categories.slice(0, 6)

  return (
    <div id="category" className={styles.categories}>
      <h2>{title}</h2>

      <div className={cn(styles.box, styles.desktop)}>
        {categoriesToShow.map((c, i) => (
          <CategoryCard key={i} c={c} isLanding={isLanding} />
        ))}
      </div>

      <div className={cn(styles.box, styles.mobile)} ref={ref}>
        {inView && (
          <CardCategoriesMobile categories={categories} isLanding={isLanding} />
        )}
      </div>

      <Button
        title={showAll ? 'View less' : 'View more'}
        theme={['black', 'medium']}
        rightImage={
          showAll
            ? '/search/arrow-top-black.svg'
            : '/search/arrow-down-black.svg'
        }
        altImg={showAll ? 'Black up arrow' : 'Black down arrow'}
        onClick={() => setShowAll((curr) => !curr)}
      />
    </div>
  )
}
